import React from "react";

function AboutDescreption() {
  return (
    <div className="py-8 w-[90%] md:w-[75%] lg:w-[60%] mx-10 text-left font-saira text-4xl md:text-5xl lg:text-6xl">
      <p className="text-white ">
        Empowering Your Fitness Journey—
        <span className="text-yellow-400"> YOUR GOAL One Rep at a Time</span>
      </p>
    </div>
  );
}

export default AboutDescreption;
